var PageOrderCheckoutPaymentResult = (function ($) {

    PageOrderCheckoutPaymentResult = function (options) {
        var that = this;

        // DOM
        that.$wrapper = options['$wrapper'];
        that.$content_wrapper = that.$wrapper.find('.js-order-checkout-result-content-wrapper');

        // CONST
        that.action = options['action'];

        that.order_hash = options['order_hash'];
        that.order_passenger_hash = options['order_passenger_hash'];
        that.order_payment_hash = options['order_payment_hash'];
        that.order_url = options['order_url'];
        that.order_passenger_hash = options['order_passenger_hash'];

        that.modal_error = options['modal_error'];

        that.onSuccess = options.onSuccess || null;
        that.onFail = options.onFail || null;

        // DYNAMIC VARS
        that.status = null;
        that.is_locked = false;

        // INIT
        that.init();
    };

    PageOrderCheckoutPaymentResult.prototype.init = function () {
        var that = this;

        if (that.action !== 'success') {
            that.__sendResultPostMessage(false);
            if (typeof this.onFail === 'function') {
                this.onFail.call(this);
            }
            return false;
        }

        //
        that.initWatch();
    };

    PageOrderCheckoutPaymentResult.prototype.initWatch = function () {
        var that = this,
            order_payment_status = null,
            href = $.sa.build_url('order/checkout/payment/status'),
            data = {
                order_hash: that.order_hash,
                order_passenger_hash: that.order_passenger_hash,
                order_payment_hash: that.order_payment_hash,
            };

        var success_statuses = [
            'issue_processing_failure',
            'issued'
        ];

        var counter = 0,
            is_locked = false,
            timer = setInterval(function () {
                if (is_locked) {
                    return;
                }

                if (counter >= 240) {
                    clearInterval(timer);
                    $.sa.content_router.load(that.order_url);
                } else {
                    is_locked = true;

                    $.post(href, data, function (res) {
                        if (res && res.data && res.data.status && res.data.status) {
                            order_payment_status = res.data.status;
                        }
                        if ($.inArray(order_payment_status, success_statuses) !== -1) {
                            clearInterval(timer);
                            if (order_payment_status === 'issue_processing_failure') {
                                that.__sendResultPostMessage(false);
                                if (typeof that.onFail === 'function') {
                                    that.onFail.call(that);
                                }
                                that.$content_wrapper.hide();
                                $.uiModal({
                                    html: that.modal_error,
                                    close_on_avia_before_load: false,
                                    onBgClick: function (modal, event) {
                                        event.preventDefault();
                                        return false;
                                    },
                                    onClose: function () {
                                        that.__handleFinish();
                                    }
                                });
                            } else {
                                that.__sendResultPostMessage(true);
                                if (typeof that.onSuccess === 'function') {
                                    that.onSuccess.call(that);
                                }
                                that.__handleFinish();
                            }
                        }
                        is_locked = false;
                    });
                    counter++;
                }
            }, 2500);
    };

    PageOrderCheckoutPaymentResult.prototype.__handleFinish = function () {
        var that = this;

        //
        localStorage.removeItem('passenger_form_data');

        //
        $.sa.content_router.load(that.order_url);
    };

    /**
     * The method is needed in case we did not receive a postmessage from the payment gateway from the iframe.
     *
     * @param is_success
     * @private
     */
    PageOrderCheckoutPaymentResult.prototype.__sendResultPostMessage = function (is_success) {
        var that = this;

        $.sa.postMessage({
            type: 'AviaIframeResult',
            data: {
                success: is_success
            }
        });
    };

    return PageOrderCheckoutPaymentResult;
})($);